export const SCREEN_INIT = "SCREEN::INIT"
export const SCREEN_UPDATE = "SCREEN::UPDATE"
export const SCREEN_TEMPLATE_SET = "SCREEN::TEMPLATE::SET"
export const SCREEN_TEMPLATE_CLEAR = "SCREEN::TEMPLATE::CLEAR"
export const SCREEN_COLOR_SET = "SCREEN::COLOR::SET"



// WEBPACK FOOTER //
// ./src/types/actions/screen.js